const getRandomDateWithinRange = () => {
  const now = new Date();
  const oneHourInMilliseconds = 60 * 60 * 1000;
  const twoHoursInMilliseconds = 2 * oneHourInMilliseconds; // Corrected variable

  // Generate a random number between 1 and 2 hours in milliseconds
  const randomDuration =
    oneHourInMilliseconds + Math.random() * twoHoursInMilliseconds;

  // Create a new date object with the random duration added to the current time
  const randomDate = new Date(now.getTime() - randomDuration);

  return randomDate;
};
export const activityData = [
  {
    label: 'New article published! Explore our latest News ',
    date: getRandomDateWithinRange(),
  },
  {
    label:
      'New article published! Explore our latest on Tobramycin, an antibiotic used for treating infections. Covers its uses, action, and dosages.',
    date: getRandomDateWithinRange(),
  },
  {
    label:
      'New article published! Explore our latest on Atorvastatin, an antibiotic used for treating infections. Covers its uses, action, and dosages.',
    date: getRandomDateWithinRange(),
  },
];
export const homeModalData = [
  {
    id: 0,
    title:
      'National Impaired Driving Prevention Month is observed in December to raise awareness about the dangers of driving under the influence of alcohol',
  },
  {
    id: 1,
    title:
      'Meningococcal disease is a serious and potentially life-threatening infection caused by the bacterium Neisseria meningitidis. It can cause a range of symptoms, including a sudden high fever, stiff neck, confusion, nausea, vomiting, fatigue, and a rash made up of small, reddish-purple spots.',
  },
  {
    id: 2,
    title:
      'Glaucoma is a group of eye conditions that damage the optic nerve, the part of the eye that sends visual information to the brain. This damage can lead to vision loss, if not treated.',
  },
  {
    id: 3,
    title:
      'National Impaired Driving Prevention Month is observed in December to raise awareness about the dangers of driving under the influence of alcohol',
  },
  {
    id: 4,
    title:
      'Meningococcal disease is a serious and potentially life-threatening infection caused by the bacterium Neisseria meningitidis. It can cause a range of symptoms, including a sudden high fever, stiff neck, confusion, nausea, vomiting, fatigue, and a rash made up of small, reddish-purple spots.',
  },
  {
    id: 5,
    title:
      'Glaucoma is a group of eye conditions that damage the optic nerve, the part of the eye that sends visual information to the brain. This damage can lead to vision loss, if not treated.',
  },
  {
    id: 6,
    title:
      'National Impaired Driving Prevention Month is observed in December to raise awareness about the dangers of driving under the influence of alcohol',
  },
  {
    id: 7,
    title:
      'Meningococcal disease is a serious and potentially life-threatening infection caused by the bacterium Neisseria meningitidis. It can cause a range of symptoms, including a sudden high fever, stiff neck, confusion, nausea, vomiting, fatigue, and a rash made up of small, reddish-purple spots.',
  },
  {
    id: 8,
    title:
      'Glaucoma is a group of eye conditions that damage the optic nerve, the part of the eye that sends visual information to the brain. This damage can lead to vision loss, if not treated.',
  },
  {
    id: 9,
    title:
      'National Impaired Driving Prevention Month is observed in December to raise awareness about the dangers of driving under the influence of alcohol',
  },
  {
    id: 10,
    title:
      'Meningococcal disease is a serious and potentially life-threatening infection caused by the bacterium Neisseria meningitidis. It can cause a range of symptoms, including a sudden high fever, stiff neck, confusion, nausea, vomiting, fatigue, and a rash made up of small, reddish-purple spots.',
  },
  {
    id: 11,
    title:
      'Glaucoma is a group of eye conditions that damage the optic nerve, the part of the eye that sends visual information to the brain. This damage can lead to vision loss, if not treated.',
  },
];
export const topicsData = [
  {id: '34', name: 'Quiz', tabId: '116', tabLabel: 'JP Winners'},
  {
    id: '9',
    name: 'Pregnancy and safety',
    tabId: '107',
    tabLabel: 'Pregnancy Drug Manual',
  },
  {
    id: '4',
    name: 'drug drug interaction',
    tabId: '113',
    tabLabel: 'Drug interactions Navigator',
  },
  {
    id: '5',
    name: 'Pharmacy management webinars',
    tabId: '106',
    tabLabel: 'Pharmacy Management Skills',
  },
  {
    id: '6',
    name: 'Selling skills',
    tabId: '114',
    tabLabel: 'Pharmacy Selling Skills',
  },
  {
    id: '7',
    name: 'General medicine',
    tabId: '104',
    tabLabel: 'Pharma Market News',
  },
  {
    id: '3',
    name: 'Newly Approved Drugs',
    tabId: '112',
    tabLabel: 'Newly Approved Drugs',
  },
  {id: '35', name: 'Surveys', tabId: '115', tabLabel: 'Surveys'},
  {
    id: '8',
    name: 'dosage calculator',
    tabId: '102',
    tabLabel: 'Dosage Calculators',
  },
];
export const miniTopicsData = [
  {id: '34', name: 'Quiz', tabId: '116', tabLabel: 'JP Winners'},
  {
    id: '9',
    name: 'Pregnancy and safety',
    tabId: '107',
    tabLabel: 'Pregnancy Drug',
  },
  {
    id: '4',
    name: 'drug drug interaction',
    tabId: '113',
    tabLabel: 'Drug interactions',
  },
  {
    id: '5',
    name: 'Pharmacy management webinars',
    tabId: '106',
    tabLabel: 'Management Skills',
  },
  {
    id: '6',
    name: 'Selling skills',
    tabId: '114',
    tabLabel: 'Selling Skills',
  },
  {
    id: '7',
    name: 'General medicine',
    tabId: '104',
    tabLabel: 'Market News',
  },
  {id: '35', name: 'Surveys', tabId: '115', tabLabel: 'Surveys'},
  {
    id: '8',
    name: 'dosage calculator',
    tabId: '102',
    tabLabel: 'Dosage Calculators',
  },
];
export const specialtyData = [
  {id: 1, name: 'Cardiology'},
  {id: 67, name: 'Dermatology'},
  {id: 37, name: 'Endocrinology'},
  {id: 116, name: 'Neurology'},
  {id: 133, name: 'Ophthalmology'},
  {id: 94, name: 'Pediatrics'},
  {id: 2, name: 'Respiratory'},
  {id: 83, name: 'Urology'},
];
export const filtersData = [
  'Health',
  'Education and Training',
  'Interactions and Risks',
  'Market News',
  'Surveys',
];
